import { jsx as _jsx } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : titleinfo wiki templates
// =============================================================================
// ---Third-party imports
import React, { useState } from 'react';
import { Item, Segment } from 'semantic-ui-react';
import clsx from 'clsx';
// ---Framework imports
import log from 'uix/logging';
import { keys, dict, filterItems, isDigit } from 'ldash';
import { useActions, useResponsive } from 'uix/hooks';
// ---Local imports
import { MiniTitleInfo } from './components';
// ---Exports
export const TitleInfo = {
    match: ({ tag })=>tag == 'TitleInfo',
    build: ({ attrib })=>/*#__PURE__*/ _jsx(MiniTitleInfo, {
            otid: isDigit(attrib.id) ? parseInt(attrib.id) : null
        }),
    completion: ({ jobSpec })=>{
        return {
            '!top': [
                'TitleInfo'
            ],
            TitleInfo: {
                attrs: {
                    id: [
                        '1',
                        '2'
                    ]
                }
            }
        };
    }
};
